import Cookie from 'js-cookie'
import VirtualPath from 'meta/utils/virtualPath'
import debounce from 'lodash/debounce'
import {CheckPosId, SetPosId, CheckLastActivity} from 'meta/utils/positiveId'

const USER_EVENTS = [
    'click',
    'keydown',
    'scroll',
    'mousemove'
]
const USER_EVENTS_TOUCH = [
    'keydown',
    'input',
    'click',
    'touchstart',
    'touchmove',
    'touchend',
    'touchenter',
    'touchleave',
    'touchcancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'scroll'
]

const USER_ACTIVITY_DEBOUNCE = 100

function refreshPatientProfileLock(visID) {
    try {
        fetch(`${VirtualPath}/webapi/visit/${visID}/refreshlock`, { method: 'POST'})
    } catch (e) {
        console.error(e)
    }
}

function updateUserActivity() {
    Cookie.set("LastActivity", new Date().getTime().toString(), { path: VirtualPath + '/' })

    window.RootAPI.FrontendEvents.webEvent(
        { type: "USER_ACTIVITY" },
        window.name
    );

    if (CheckPosId()) {
        SetPosId()
    }
}

function setupUserActivityChecking(window) {
    let events = (/iphone|ipad/gi).test(navigator.appVersion) ? USER_EVENTS : USER_EVENTS_TOUCH
    let eventFnMap = []
    var debouncedLockRefresh = null;
    updateUserActivity();
    for (var i = 0; i < events.length; i++) {
        eventFnMap.push({
            event: events[i],
            fn: debounce(function() {
                updateUserActivity()
                if (!debouncedLockRefresh) {
                    let lockButton = window.document.querySelector("#ctl00_ctl00_A_cmdProfileLockUnlock")
                    if (lockButton) {
                        debouncedLockRefresh = debounce(function() {
                            refreshPatientProfileLock(lockButton.getAttribute("visID"))
                        }, parseInt(lockButton.getAttribute("reload_every"), 10))
                    }
                }
                if (debouncedLockRefresh) {
                    debouncedLockRefresh()
                }
            }, USER_ACTIVITY_DEBOUNCE)
        })
    }

    // add event listener for capture handler
    eventFnMap.forEach((e) => window.document.addEventListener(e.event, e.fn, {capture: true}))


    window.addEventListener('pagehide', function() {
        eventFnMap.forEach((e) => window.document.removeEventListener(e.event, e.fn))
    })
}

function checkUserActivity() {
    try {
        if (!CheckLastActivity()) {
            window.RootAPI.Navigation.inactivityLogout();
        }
    } catch (e) {
        console.error(e)
    }
      
}

export {
    setupUserActivityChecking,
    updateUserActivity,
    checkUserActivity
}
